import { useRef, useState } from 'react';

import { DownIcon } from '../../../../assets/svg/DownIcon';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { PaymentMultiuse } from '../../../../models/payment-links-multiuse';
import { DropdownContainer, DropdownItem, DropdownList } from './styles';

interface Options {
	label: string;
	onClick: (rowData: PaymentMultiuse) => void;
	colorCustom?: string;
}

interface DropdownProps {
	options: Options[];
	rowData: PaymentMultiuse;
}

const Dropdown = ({ options, rowData }: DropdownProps) => {
	const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
	const modal = useRef<HTMLDivElement>(null);

	const toggleDropdown = () => {
		setIsDropdownVisible(!isDropdownVisible);
	};

	const handleItemClick = (onClick: (rowData: PaymentMultiuse) => void) => {
		onClick(rowData);
		setIsDropdownVisible(false);
	};

	useClickOutside({ elementRef: modal, callback: () => setIsDropdownVisible(false) });

	return (
		<>
			<DownIcon onClick={toggleDropdown} />
			{isDropdownVisible && (
				<DropdownContainer ref={modal}>
					<DropdownList>
						{options?.map(({ label, onClick, colorCustom }) => (
							<DropdownItem
								key={label}
								onClick={() => handleItemClick(onClick)}
								colorCustom={colorCustom}
							>
								{label}
							</DropdownItem>
						))}
					</DropdownList>
				</DropdownContainer>
			)}
		</>
	);
};

export { Dropdown };
